import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { BRAND } from '../data/siteContent';
import { seoForPath, absoluteUrl } from '../utils/seo';

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/**
 * Client-side SEO tags for public marketing pages (title, description, Open Graph, canonical).
 */
export default function SeoHead({ title, description, image }) {
  const location = useLocation();
  const fallback = seoForPath(location.pathname);
  const pageTitle = title || fallback.title;
  const pageDesc = description || fallback.description;
  const url = absoluteUrl(location.pathname);
  const ogImage = image || absoluteUrl('/Logo.png');

  useEffect(() => {
    document.title = pageTitle;
    upsertMeta('name', 'description', pageDesc);
    upsertMeta('name', 'robots', 'index, follow');
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:site_name', BRAND.name);
    upsertMeta('property', 'og:title', pageTitle);
    upsertMeta('property', 'og:description', pageDesc);
    upsertMeta('property', 'og:url', url);
    upsertMeta('property', 'og:image', ogImage);
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', pageTitle);
    upsertMeta('name', 'twitter:description', pageDesc);
    upsertLink('canonical', url);
  }, [pageTitle, pageDesc, url, ogImage]);

  return null;
}
